import React, { useState, useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Box from '@material-ui/core/Box';
import { DialogContents, DialogTitles, Dialogs } from '../../../Core/FormInput';

class PreviewErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Preview Render Error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 20, textAlign: 'center', color: '#f44336' }}>
                    <h3 style={{ marginBottom: 10 }}>Live Preview Unavailable</h3>
                    <p>This specific component relies heavily on real user or job data and cannot be fully previewed without it.</p>
                    <div style={{ background: '#ffebee', padding: 15, borderRadius: 5, marginTop: 15, textAlign: 'left', overflow: 'auto' }}>
                        <code>{this.state.error?.toString()}</code>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

const WebFormPreviewModal = ({ open, handleClose, url }) => {
    const [targetMenu, setTargetMenu] = useState(null);

    useEffect(() => {
        const loadMenu = async () => {
            const menuModule = await import('../../../Core/Root/menu/roles-menu/web-form-menu');
            const webFormMenu = menuModule.default;
            
            const baseDbUrl = url ? url.split('?')[0] : '';
            const matchedMenu = webFormMenu.find((menu) => {
                const baseMenuPath = menu.path.split('/:')[0];
                return baseMenuPath === baseDbUrl;
            });
            setTargetMenu(matchedMenu);
        };
        
        if (open && url) {
            loadMenu();
        }
    }, [open, url]);

    const ComponentToPreview = targetMenu ? targetMenu.component : null;

    return (
        <Dialogs open={open} onClose={handleClose} maxWidth="xl" fullWidth>
            <Box display="flex" alignItems="center">
                <Box flexGrow={1}>
                    <DialogTitles>Preview Web Form: {targetMenu ? targetMenu.label : (url ? url.split('?')[0] : '')}</DialogTitles>
                </Box>
                <Box>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Box>
            <DialogContents style={{ overflow: 'auto', height: 'calc(100vh - 100px)' }}>
                {ComponentToPreview ? (
                    <PreviewErrorBoundary key={targetMenu?.path}>
                        <ComponentToPreview 
                            previewMode={true} 
                            isReadOnly={true} 
                            isTechReadonly={true} 
                            location={{ search: '' }}
                            match={{ params: { jobId: 0, headerRecordID: 0 } }}
                        />
                    </PreviewErrorBoundary>
                ) : (
                    <div style={{ padding: 20, textAlign: 'center' }}>Preview not available for this component</div>
                )}
            </DialogContents>
        </Dialogs>
    );
};

export default WebFormPreviewModal;
